import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeadIconChevron = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 50 32",
	...props,
	children: /* @__PURE__ */ _jsx("polygon", {
		strokeWidth: 2,
		fillRule: "nonzero",
		points: "1,1 9,16 1,31 41,31 49,16 41,1",
		strokeLinejoin: "round"
	})
});
export default SvgLeadIconChevron;
